import AppConstants from '../constants/constants.json';

export default {
    data() {
        return {
            finametricaSourceAPI: AppConstants.finametricaSourceAPI,
            esgSourceAPI: AppConstants.esgSourceAPI,
        }
      }
}